import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { COLORS } from '@gc-npm/utils.enums.colors';
import CustomLink from '@gc-npm/components.custom-link';
import TextInfo, {
  TEXT_KIND,
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
} from '@gc-npm/components.text';
import Glyph from '@gc-npm/components.icon-glyph';
import { actions as uiActions } from '@/reducers/ui';

const COMPONENT_NAME = 'AutoSelection';

const AutoSelection = ({
  modules,
}) => {
  const dispatch = useDispatch();
  const timer = useRef(null);

  const taggingInfo = {
    componentName: COMPONENT_NAME,
    componentContent: '',
    componentProduct: '',
    componentVariation: '',
  };

  const onCloseModal = () => {
    if (timer.current) {
      clearTimeout(timer.current)
    }
    dispatch(uiActions.setAutoSelection(null));
  }

  useEffect(() => {
    // Crea un temporizador para ejecutar onSubmit después de 3 segundos
    timer.current = setTimeout(() => {
      onCloseModal();
    }, 6000);
    // Almacena el ID del temporizador para poder cancelarlo más tarde
    // Limpia el temporizador cuando el componente se desmonta
    return () => clearTimeout(timer.current);
  }, []);

  if (
    !modules
    || !Array.isArray(modules)
    || !modules.length > 0
  ) {
    onCloseModal();
  }

  let textInfo = '';
  modules.forEach(({ title, hide }) => {
    if (!hide) {
      textInfo += `${textInfo ? ' y ' : ''}<strong>${title?.text}</strong>`;
    }
  });

  if (textInfo) {
    textInfo = `${modules.length > 1 ? 'Se han añadido los paquetes obligatorios' : 'Se ha añadido el paquete obligatorio'} ${textInfo}`
  } else {
    onCloseModal();
    return null;
  }

  return (
    <>
      <div className="AutoSelection">
        <div className="AutoSelection__wrapper">
          <TextInfo
            className="AutoSelection__wrapper__text"
            text={textInfo}
            kind={TEXT_KIND.PARAGRAPH}
            color={TEXT_COLOR.WHITE}
            size={TEXT_SIZE.T7}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
          />
          {onCloseModal && (
            <div className="AutoSelection__wrapper__cerrar">
              <CustomLink
                taggingInfo={{ ...taggingInfo, componentContent: 'cerrar' }}
                onClick={onCloseModal}
              >
                <Glyph
                  id="cerrar"
                  height={14}
                  width={14}
                  color={TEXT_COLOR.WHITE}
                />
              </CustomLink>
            </div>
          )}
        </div>
      </div>
      <style jsx>
        {`
            .AutoSelection {
              z-index: 999;
              width: -webkit-fill-available;
              position: fixed;
              bottom: 1rem;
              display: flex;
              justify-content: center;
                &__wrapper {
                  width: fit-content;
                  display: flex;
                  align-items: center;
                  gap: 1rem;
                  background-color: ${COLORS.grey600};
                  padding: 1rem;
                  border-radius: 1rem;
                  :global(.AutoSelection__wrapper__text) {
                    display: flex;
                    gap: 0.5rem;
                    :glboal(strong) {
                      color: ${COLORS.movistarBlue};
                    }
                  }
                }
            }
             @media (max-width: 768px) {
                .AutoSelection{
                    bottom: 5rem;
                    &__wrapper {
                      width: 90vw;
                      align-items: flex-start;
                    }
                }
             }
        `}

      </style>
    </>
  );
};

export default AutoSelection;
